export enum NotTuru{
    gorusme=1,
    haciz_satis_rehin,
    borclu,
    alacakli,
    tebligat,
    ozel,
    diger = 7
}

export enum NotTuruLabel{
    "Görüşme"=1,
    "Haciz-Satış-Rehin",
    "Borçlu",
    "Alacaklı",
    "Tebligat",
    "Özel",
    "Diğer" = 7
}